import { useLocation, useNavigate } from 'react-router';
import { Button } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlinePlusIcon } from '@tempmee/react-icons';
import { CreateOnsiteInterviewSteps } from '../../CreateOnsiteInterview';

interface IAddMoreOnsiteInterviewButtonProps {
  jobPostingId: string;
  includeLocationState?: boolean;
  variant?: 'default' | 'lite';
  onTrack?: () => void;
}

export const AddMoreOnsiteInterviewButton = ({
  includeLocationState = false,
  jobPostingId,
  variant = 'default',
  onTrack,
}: IAddMoreOnsiteInterviewButtonProps) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleClick = () => {
    // Call tracking callback if provided
    onTrack?.();

    navigate(
      // eslint-disable-next-line max-len
      `/permanent-jobs/postings/${jobPostingId}/onsite-interviews/create/${CreateOnsiteInterviewSteps.WorkDetails}`,
      includeLocationState ? { state } : undefined,
    );
  };

  if (variant === 'lite') {
    return (
      <Button
        size="xs"
        variant="secondary"
        LeadingIcon={<OutlinePlusIcon color={colors.shades[0]} />}
        onClick={handleClick}
      >
        Add Interviews
      </Button>
    );
  }

  return (
    <Button size="lg" onClick={handleClick}>
      Add Interviews
    </Button>
  );
};
